import React, { FC } from "react";
import { useRoutes } from "react-router-dom";
import { Home, Blog, BlogPost, NotFound, Calculator } from "src/pages";
import { PATHNAMES } from "src/constants/routes";

const ROUTES = [
  {
    element: <Home />,
    path: PATHNAMES.HOME,
  },
  {
    element: <Blog />,
    path: PATHNAMES.BLOG,
  },
  {
    element: <BlogPost />,
    path: PATHNAMES.BLOG_ITEM(":id"),
  },
  {
    element: <Calculator />,
    path: PATHNAMES.CALCULATOR,
  },
  {
    element: <NotFound />,
    path: PATHNAMES.NOT_FOUND,
  },
];

const AppRoutes: FC = () => {
  return useRoutes(ROUTES);
};

export default AppRoutes;
